import { useCallback, useMemo } from "react";

import { Form, FormikForm } from "@skilitics/designer-ui-components";

import { StringComparisonView, stringComparisonFormatStrings } from "../../../values/forms/comparison-views/index.ts";
import type { StringConditionContext } from "../stringConditionBuilder";

type Config = Omit<StringConditionContext["config"], "refs">;

type FormValues = Config;

interface StringConditionFormProps {
  config: Config;
  onConfigChange: (values: Config) => void;
  disabled?: boolean;
}

export const StringConditionForm = ({ disabled = false, config, onConfigChange }: StringConditionFormProps) => {
  const initialValues: FormValues = useMemo(
    () => ({
      operator: config.operator,
      value: config.value,
    }),
    [config.operator, config.value],
  );

  const handleSubmit = useCallback(
    (values: FormValues) => {
      onConfigChange({ ...config, ...values });
    },
    [config, onConfigChange],
  );

  return (
    <FormikForm<FormValues>
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitOnBlur
      explicitLabels
      formatStrings={stringComparisonFormatStrings}
      dataTest="string-condition-form"
    >
      <Form $labelAlignment="inline">
        <StringComparisonView disabled={disabled} />
      </Form>
    </FormikForm>
  );
};
